var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}

export { getDefaultOptions };
//# sourceMappingURL=index.js.map
